import React, { Component } from 'react'

import { TextField } from '@mui/material'
import classNames from 'classnames'
import { formField } from 'decorators'

import { input } from '@albacross/frontend-utils'

type FormTextFieldProps = {
  className?: string
  errorId?: string | boolean
  field?: Record<string, any>
  helperText?: string
  type?: string
  warningId?: string | boolean
  onChange?: (...args: any[]) => any
}

class FormTextField extends Component<FormTextFieldProps> {
  static defaultProps = {
    className: '',
    fullWidth: true,
    type: 'text',
  }

  inputRef = React.createRef<HTMLInputElement>()
  selection: { start: number | boolean | null; end: number | boolean | null } = {
    start: false,
    end: false,
  }

  componentDidUpdate() {
    const input = this.inputRef.current
    if (!input) return

    const { selectionStart, selectionEnd } = input

    const update =
      (this.selection.start !== false && this.selection.start !== selectionStart) ||
      (this.selection.end !== false && this.selection.end !== selectionEnd)

    if (update) {
      input.selectionStart = this.selection.start as number
      input.selectionEnd = this.selection.end as number
    }
  }

  handleChange = (e: any) => {
    const { onChange, type } = this.props
    const input = this.inputRef.current
    this.selection = {
      start: input?.selectionStart ?? null,
      end: input?.selectionEnd ?? null,
    }
    // Keep an emptied number field empty — Number('') is 0, which otherwise sticks as a filter value.
    onChange?.(type === 'number' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value, e)
  }

  render() {
    const { field, className, errorId, helperText, warningId, ...rest } = this.props

    return (
      <div className={classNames('form-text-field', className)}>
        <TextField
          {...rest}
          error={!!errorId}
          helperText={errorId || helperText}
          inputRef={this.inputRef}
          onChange={this.handleChange}
        />
      </div>
    )
  }
}

export default formField(input('')(FormTextField))
